import React from 'react';
import MediumEditorWrapper from './MediumEditorWrapper';

export default (props) => {
  const {
    editable,
    text,
    placeholder,
    editorOptions,
    onChange,
    onKeyDown,
    onClick,
    wrapperClassName
  } = props;

  if (editable) {
    return (
      <MediumEditorWrapper
        className={wrapperClassName + ' captionText'}
        value={text}
        placeholder={placeholder}
        options={editorOptions}
        simpleEditor={true}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onClick={onClick}
      />
    );
  }

  const StaticTextComponent = props.staticTextComponent || 'div';

  return (
    <StaticTextComponent
      className={wrapperClassName + ' text-view-custom-container'}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};
